module.exports = __webpack_public_path__ + "img/d08.dbe8a695.jpg";